import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RoomSession } from '../../models/Room'
import { RootState } from '../store'

interface LiveMeetingsState {
  liveMeetings: RoomSession[] | null
  liveMeetingsPollingEnabled: boolean
  isLiveMeetingsLoading: boolean
  hasLiveMeeting: boolean
}

const initialState: LiveMeetingsState = {
  liveMeetings: null,
  liveMeetingsPollingEnabled: false,
  isLiveMeetingsLoading: false,
  hasLiveMeeting: false,
}

export const liveMeetingsSlice = createSlice({
  name: 'liveMeetings',
  initialState,
  reducers: {
    setLiveMeetings: (state, action: PayloadAction<RoomSession[] | null>) => {
      state.liveMeetings = action.payload
    },
    startLiveMeetingsPolling(state) {
      state.liveMeetingsPollingEnabled = true
    },
    stopLiveMeetingsPolling(state) {
      state.liveMeetingsPollingEnabled = false
    },
    setLiveMeetingsLoading(state, action: PayloadAction<boolean>) {
      state.isLiveMeetingsLoading = action.payload
    },
    setHasLiveMeeting: (state, action: PayloadAction<boolean>) => {
      state.hasLiveMeeting = action.payload
    },
    resetLiveMeetings: () => initialState,
  },
})

export const { setLiveMeetings, startLiveMeetingsPolling, stopLiveMeetingsPolling, setLiveMeetingsLoading, setHasLiveMeeting, resetLiveMeetings } =
  liveMeetingsSlice.actions

export const selectLiveMeetings = (state: RootState) => state.liveMeetings.liveMeetings

export const selectLiveMeetingsPollingEnabled = (state: RootState) => state.liveMeetings.liveMeetingsPollingEnabled

export const selectLiveMeetingsIsLoading = (state: RootState) => state.liveMeetings.isLiveMeetingsLoading

export const selectHasLiveMeetings = (state: RootState) => state.liveMeetings.hasLiveMeeting

export default liveMeetingsSlice.reducer
